import { formatDayToHour } from 'utils/date/format.util';

const generatePaymentsReportFileName = ({ salonId, timestamp }) => `${salonId} SlickPay invoice ${formatDayToHour(timestamp)} .pdf`;

export default generatePaymentsReportFileName;
